import { render, staticRenderFns } from "./BaseFilterTagItemSearches.vue?vue&type=template&id=aed295a2&scoped=true"
import script from "./BaseFilterTagItemSearches.vue?vue&type=script&lang=js"
export * from "./BaseFilterTagItemSearches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed295a2",
  null
  
)

export default component.exports